import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    constructor() {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.url.startsWith('/api')) return next.handle(request);

        const clonedReq = request.clone({
            url: request.url.includes(environment.office_api_host) ? request.url : environment.office_api_host + request.url,
        });

        return next.handle(clonedReq);
    };

}
